/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
class EnableIntegration {
  constructor() {
    this.enableIntegration = true;
  }

  ResetAPIIntegration() {
    this.enableIntegration = true;
    localStorage.removeItem('enableIntegration');
  }

  ToggleAPIIntegration(apiStatus) {
    this.enableIntegration = apiStatus;
    localStorage.setItem('enableIntegration', apiStatus);
  }

  EnableAPIIntegration() {
    this.enableIntegration = true;
    localStorage.setItem('enableIntegration', true);
  }

  DisableAPIIntegration() {
    this.enableIntegration = false;
    localStorage.setItem('enableIntegration', false);
  }

  isAPIIntegrationEnabled() {
    return this.enableIntegration;
  }
}

export default new EnableIntegration();
